"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    defaultDomainIDConfig: ()=>defaultDomainIDConfig,
    getDomainIDConfig: ()=>getDomainIDConfig
});
const core_lib_namespaceObject = require("@bytecloud/core-lib");
const once_namespaceObject = require("lodash/once");
var once_default = /*#__PURE__*/ __webpack_require__.n(once_namespaceObject);
const external_domain_id_config_js_namespaceObject = require("./domain-id.config.js");
const query_config_js_namespaceObject = require("../utils/query.config.js");
const defaultDomainIDConfig = {
    domainIDNameMap: external_domain_id_config_js_namespaceObject.domainIDNameMap,
    domainIDHostnameMap: external_domain_id_config_js_namespaceObject.domainIDHostnameMap,
    allDomainIDs: external_domain_id_config_js_namespaceObject.allDomainIDs
};
const getDomainIDConfig = once_default()(async ()=>{
    const tccProxy = new core_lib_namespaceObject.TccProxy({
        namespace: 'bytecloud.fe.config',
        key: 'domainID',
        isPreview: (0, query_config_js_namespaceObject.checkTccProxyFlag)('preview', 'domainid-config'),
        isTest: (0, query_config_js_namespaceObject.checkTccProxyFlag)('test', 'domainid-config'),
        defaultValue: defaultDomainIDConfig,
        hostname: 'undefined' != typeof location ? location.hostname : '',
        fetchStrategy: 'networkFirst',
        validator (value) {
            try {
                return Object.prototype.hasOwnProperty.call(value, 'domainIDHostnameMap');
            } catch (error) {
                return false;
            }
        },
        useFallbackHostname: true
    });
    return await tccProxy.getConfig() || defaultDomainIDConfig;
});
exports.defaultDomainIDConfig = __webpack_exports__.defaultDomainIDConfig;
exports.getDomainIDConfig = __webpack_exports__.getDomainIDConfig;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "defaultDomainIDConfig",
    "getDomainIDConfig"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
